import { css } from 'linaria';

export const AdLabelLegalDataWrapperStyles = css`
  display: flex;
  flex-direction: column;
  min-width: 240px;
  color: var(--text-primary-invert, #fff);
`;

export const colorTextPrimary = css`
  color: var(--text-primary, #000);
`
